//
import { ExtendFile } from 'src/components/file-thumbnail/types';
import { withImageSize } from 'src/utils/optimizedImageUrl';
import Image from '../../image';
//

// ----------------------------------------------------------------------

type Props = {
  file: ExtendFile | string | null;
};

export default function AvatarPreview({ file }: Props) {
  if (!file) {
    return null;
  }

  const raw = typeof file === 'string' ? file : file.preview;
  const imgUrl = withImageSize(raw || '', 'md');

  return (
    <Image
      alt="avatar"
      src={imgUrl}
      sx={{
        zIndex: 8,
        overflow: 'hidden',
        borderRadius: '50%',
        position: 'absolute',
        width: `calc(100% - 16px)`,
        height: `calc(100% - 16px)`,
      }}
    />
  );
}
